import React from 'react';
import ReactDOM from 'react-dom';

const DeleteModal = ({ showModal, handleCloseModal, handleConfirm, confirmButtonName }) => {
    if (!showModal) return null;

    return ReactDOM.createPortal(
        <div className="relative z-[9999]" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                style={{ zIndex: 9998 }}
                aria-hidden="true"
                onClick={handleCloseModal}
            />

            {/* Modal panel */}
            <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 9999 }}>
                <div className="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-2xl transition-all w-full max-w-sm">

                    {/* Close button */}
                    <button
                        type="button"
                        className="absolute top-3 right-3 p-1.5 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors focus:outline-none"
                        onClick={handleCloseModal}
                        aria-label="Close"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

                    {/* Icon + text */}
                    <div className="flex flex-col items-center px-6 pt-8 pb-2 text-center">
                        <div
                            className="flex items-center justify-center w-20 h-20 rounded-full mb-4"
                            style={{ backgroundColor: '#fee2e2' }}
                        >
                            <svg
                                width="38"
                                height="38"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#dc2626"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <polyline points="3 6 5 6 21 6" />
                                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                <path d="M10 11v6M14 11v6" />
                                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                            </svg>
                        </div>

                        <h3 className="text-lg font-semibold text-gray-800 mb-1" id="modal-title">
                            Delete Template
                        </h3>
                        <p className="text-sm text-gray-500 leading-relaxed">
                            Are you sure you want to delete this Template?
                        </p>
                        <p className="text-sm text-gray-400 mt-1">
                            This action cannot be undone.
                        </p>
                    </div>

                    {/* Divider */}
                    <div className="mx-6 mt-2 border-t border-gray-100" />

                    {/* Actions */}
                    <div className="flex gap-3 px-6 py-4">
                        <button
                            type="button"
                            className="flex-1 rounded-xl py-2.5 text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors focus:outline-none"
                            onClick={handleCloseModal}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="flex-1 rounded-xl py-2.5 text-sm font-semibold text-white transition-colors focus:outline-none"
                            style={{ backgroundColor: '#dc2626' }}
                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#b91c1c'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#dc2626'; }}
                            onClick={handleConfirm}
                        >
                            {confirmButtonName || 'Delete'}
                        </button>
                    </div>

                </div>
            </div>
        </div>,
        document.body
    );
};

export default DeleteModal;
